<template>
    <div class="overview">
      <a-row :gutter="20" style="margin-left: 0px"  >
        <a-col :span="18" class="f-row" >
          <a-card :bordered="true" style="width: 100%">
            <a-row class="f-row">
              <a-col :span="8" style="text-align: center">
                <!--<a-icon type="user" style="font-size: 80px;margin-top: 10px"/>-->
                <div style="border-radius: 50%;height: 80px;width: 80px;margin-left: calc((100% - 80px)/2); background-size: 100% " :style="{backgroundImage:'url('+require('@/assets/'+(userInfo().sex===1?'doc-1.jpg':'doc-2.jpg'))+')'}"></div>
                <div style="font-size: 20px;color: #2290ff;margin-top: 10px">
                  您好！{{nickname()}}
                </div>
                <div style="font-size: 20px;margin-top: 10px">
                  {{nowTime()}}
                </div>
              </a-col>
              <a-col :span="16" style="margin-top: 20px">
                <p style="font-size: 20px">
                  所处中心：{{projectUserInfo.center_name}}
                </p>
                <p style="font-size: 20px">
                  您的角色：
                  {{projectUserInfo.role_name}}
                </p>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
        <a-col :span="6" >
          <a-card title="项目消息" :bordered="true" style="width: 100%" >
            <div slot="extra" >
              <a-button type="link" @click="viewInfo">查看详情</a-button>
            </div>
            <div style="height: 128px" class="f-row2">
              <p>项目简介：{{project.name}}</p>
              <p>项目负责人：{{project.contactName}}</p>
              <p>项目进度：
                <project-status :status="project.status"></project-status>
              </p>
            </div>
          </a-card>
        </a-col>
      </a-row>


      <a-row :gutter="20" style="margin-top: 5px">

        <a-col :span="18">
          <a-col :span="24">
            <a-card title="待办事项" :bordered="true" style="width: 100%">
              <a-row class="dbsx" >
                <a-col :span="4" v-for="(info,index) in infoList" class="dbsx-info" :key="index">
                  <div class="num">{{info}}</div>
                  <div>{{index}}</div>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col :span="24" style="margin-top: 5px" v-if="inited">
            <a-card title="项目当前进度" :bordered="true" style="width: 100%">
              <a-row >
                <a-col :span="8" class="progress" v-for="(item,index) in progressList" :key="index">
                  <c-pie :description2="item.title"  :description="item.text" :datasource="item.value" :pro-color="progressColorList[index]"></c-pie>
                  <!--<div class="title">-->
                    <!--项目时间：{{progressValue}}%-->
                  <!--</div>-->
                  <!--<div class="info">{{item.text}}</div>-->
                </a-col>
                <!--<a-col :span="8" class="progress">-->
                  <!--<c-pie title="入组病历" :datasource="progressValue"></c-pie>-->
                  <!--<div class="info">{{progressValue}}/100</div>-->
                <!--</a-col>-->
                <!--<a-col :span="8" class="progress">-->
                  <!--<c-pie title="提交表单数" :datasource="progressValue"></c-pie>-->
                  <!--<div class="info">{{progressValue}}/100</div>-->
                <!--</a-col>-->
              </a-row>
            </a-card>
          </a-col>
        </a-col>

        <a-col :span="6">
          <a-card title="公告栏" style="width: 100%">
            <div slot="extra" >
              <a-button type="link" @click="newNotice()">新增公告</a-button>
              <a-divider type="vertical" />
              <a-button type="link" @click="noticeReadAll()">全部标记已读</a-button>
            </div>
            <div class="notice-panel">
              <p style="width: 100%;" class="notice"  v-for="(item,index) in noticeList" :key="index" @click="viewNotice(item)">
                <label class="notice" :class="item.userIds && item.userIds.indexOf(userInfo().id)>=0?'':'no-read'">{{item.title}}</label>
                <label class="notice notice-time" :class="item.userIds && item.userIds.indexOf(userInfo().id)>=0?'':'no-read'">{{item.createTime}}</label>
              </p>
            </div>
          </a-card>
        </a-col>

      </a-row>

      <a-modal
        title="新增公告"
        :width="1000"
        :visible="noticeVisible"
        :confirmLoading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        cancelText="关闭">

        <a-spin :spinning="confirmLoading">
          <a-form-model layout="horizontal" ref="noticeForm" :rules="rules" :model="noticeForm" v-bind="{
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }">
            <a-form-model-item label="标题" prop="title">
              <a-input  v-model="noticeForm.title" placeholder="请输入" />
            </a-form-model-item>
            <a-form-model-item label="内容" prop="content">
              <a-textarea :rows="6" v-model="noticeForm.content" placeholder="请输入" />
            </a-form-model-item>
            <a-form-model-item label="上传文件">
              <a-upload name="file"  :multiple="false"
                        :headers="tokenHeader" :data="{biz:'/project/'+projectId+'/'+fileType+'/'+new Date().getTime()}" :action="importExcelUrl" @change="handleUploadChange">
                <a-button type="primary" icon="import">上传文件</a-button>
              </a-upload>
            </a-form-model-item>
          </a-form-model>
        </a-spin>
      </a-modal>
      <a-modal
        title="公告"
        :width="1000"
        :visible="noticeViewVisible"
        @cancel="noticeViewVisible = false"
        :footer="null">
        <div style="text-align: center;font-size: 24px">
          {{noticeForm.title}}
        </div>
        <div style="font-size: 18px;margin-top: 20px;margin-bottom: 20px">
          {{noticeForm.content}}
        </div>
        <div>
          <p v-for="(file,index) in noticeForm.fileList" :key="index">
            {{file}}<a-button type="link" @click="downloadFileHandle(index)">下载</a-button>
          </p>
        </div>
      </a-modal>
    </div>
</template>

<script>
  import ProjectStatus from '@/views/management/project/projectList/ProjectStatus'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import Vue from 'vue'
  import moment from 'moment'
  import {  mapGetters } from 'vuex'
  import CPie from './components/CPie'
  import { getAction ,postAction,downloadFile} from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: 'Overview',
    components: { CPie,ProjectStatus  },
    inject: ['viewInfoFn'],
    data() {
      return {
        rules:{
          title:[baseRules.required],
          content:[baseRules.required],
        },
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        fileType:'5',
        projectId:Vue.ls.get(CACHE_PROJECT_ID) || '',
        noticeVisible:false,
        noticeViewVisible: false,
        confirmLoading:false,
        marks: {
          0: '0%',
          50:'50%',
          100: '100%',
        },
        progressValue:20,
        data:[
          { item: '事例一', count: 40 },
          { item: '事例二', count: 21 },
        ],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        noticeForm:{
          files:''
        },
        defaultFileList:[{
          uid: '2',
          name: 'yyy.png',
          status: 'done',
          url: 'http://www.baidu.com/yyy.png',
        }],
        inited:false,
        project:{},
        infoList:{},
        progressList:[],
        progressColorList:['rgba(19,183,197,0.9)','rgba(245,115,41,0.9)','rgba(58,124,253,0.9)'],
        projectUserInfo:{
          roleList:[]
        },
        noticeList:[],
      }
    },
    created() {
      this.inited = false //处理项目当前进度变形
      this.$nextTick(()=>{
        this.inited=true
      })
      this.loadData()
    },
    computed: {
      importExcelUrl() {
        return `${window._CONFIG['domianURL']}/sys/common/upload`
      }
    },
    methods: {
      loadNotice(){
        getAction('/project/projectNotice/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.noticeList=res.result
          }
        })
      },
      loadData(){
        this.loadNotice()
        getAction('/management/project/projectUserInfo',{id:this.projectId}).then(res=>{
          if(res.success){
            this.projectUserInfo=res.result
          }
        })
        getAction('/management/project/getViewInfoById',{id:this.projectId}).then(res=>{
          if(res.success){
            this.project = res.result
            getAction('/management/project/getProgressById',{id:this.projectId}).then(res=>{
              if(res.success){
                this.progressList=res.result
              }
            })
            const infoList = {}
            this.project.infoList.forEach(info=>{
              for(let key in info){
                if((infoList[key]===null || infoList[key]===undefined)){
                  infoList[key] = info[key]
                }
              }
            })
            this.infoList = infoList
          }
        })
      },
      ...mapGetters(["nickname","userInfo"]),
      nowTime(){
        return  moment().format('YYYY-MM-DD HH:mm:ss')
      },
      newNotice(){
        this.noticeForm = {}
        this.noticeVisible =true
      },
      handleOk(){
        this.$refs.noticeForm.validate(valid  => {
          if(valid){
            this.confirmLoading =true
            this.noticeForm.projectId = this.projectId
            postAction('/project/projectNotice/saveOrUpdate',this.noticeForm).then(res=>{
              if(res.success){
                this.loadNotice()
                this.handleCancel()
              }
            }).finally(()=>{
              this.confirmLoading =false
            })
          }
        })
      },
      noticeReadAll(){
        postAction('/project/projectNotice/noticeReadAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.loadNotice()
          }
        }).finally(()=>{
        })
      },
      handleCancel(){
        this.noticeVisible =false
      },
      viewNotice(record){
        record.fileList = record.files?record.files.split(','):[]
        record.pathList = record.paths?record.paths.split(','):[]
        this.noticeForm = record
        this.noticeViewVisible =true
        postAction('/project/projectNotice/read',{id:record.id}).then(res=>{
          if(res.success){
            this.loadNotice()
          }
        }).finally(()=>{
        })
      },
      viewInfo(){
          this.viewInfoFn()
      },
      downloadFileHandle(index){
        downloadFile('/sys/common/static'+this.noticeForm.pathList[index],this.noticeForm.fileList[index])
      },
      handleUploadChange(info) {
        // if (info.file.status !== 'uploading') {
        //   console.log(info.file, info.fileList);
        // }
        if (info.file.status === 'done' || info.file.status === 'removed') {
          let paths = ''
          let files = ''
          if(info.fileList){
            info.fileList.forEach(item=>{
              if(paths){
                paths +=','+ item.response.message
                files +=','+ item.name
              }else{
                paths = item.response.message
                files = item.name
              }
            })
          }
          this.$set(this.noticeForm,'paths',paths);
          this.$set(this.noticeForm,'files',files);
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} file upload failed.`);
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .progress{
    text-align: center;
    .info{
      margin-top: -30px;
      /*margin-left: 3%;*/
    }
  }
  .dbsx{
    text-align: center;
    .num{
      font-size: 30px;
    }
    .dbsx-info{
      cursor: pointer;
    }

  }
</style>
<style lang="less">
  .f-row{
    min-height: 170px;
  }
  .f-row2{
    min-height: 130px;
  }
  .overview{
    padding-left: 5px;
    padding-right: 5px;
    .ant-card-body{
      padding: 10px;
    }
    .no-read{
      color: #e74c3c;
    }
    .notice{
      cursor: pointer;
    }
    .notice-time{
      float: right;
    }
    .notice-panel{
      height: calc(100vh - 500px);
      overflow-y: auto;
    }
  }
</style>
